import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link } from 'react-router-dom';
export function OrderSearch() {
  const orders = [{
    id: 1001,
    orderNumber: 'ORD-2023-001',
    products: 'Desert Ecology Basics',
    subtotal: '$49.00',
    status: 'Processed',
    customer: 'John Doe',
    date: '2023-10-15',
    total: '$49.00'
  }, {
    id: 1002,
    orderNumber: 'ORD-2023-002',
    products: 'Advanced Water Conservation',
    subtotal: '$79.00',
    status: 'Failed',
    customer: 'Alice Smith',
    date: '2023-10-16',
    total: '$79.00'
  }, {
    id: 1003,
    orderNumber: 'ORD-2023-003',
    products: 'Sustainable Landscaping',
    subtotal: '$39.00',
    status: 'Not Finished',
    customer: 'Bob Wilson',
    date: '2023-10-17',
    total: '$39.00'
  }];
  return <div className="space-y-4" data-id="element-1335">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1336">Order Search</h1>

      <div className="space-y-2" data-id="element-1337">
        <div data-id="element-1338">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1339">Date</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-1340">
            <option data-id="element-1341">Today</option>
            <option data-id="element-1342">All Dates</option>
            <option data-id="element-1343">This Week</option>
            <option data-id="element-1344">This Month</option>
          </select>
        </div>
        <div data-id="element-1345">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1346">Coupon</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-1347">
            <option data-id="element-1348">&lt;Ignore&gt;</option>
            <option data-id="element-1349">SUMMER23</option>
            <option data-id="element-1350">WELCOME</option>
          </select>
        </div>
        <div data-id="element-1351">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1352">
            Reseller
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-1353">
            <option data-id="element-1354">&lt;Ignore&gt;</option>
            <option data-id="element-1355">Partner A</option>
          </select>
        </div>
        <div data-id="element-1356">
          <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1357">
            Search
          </Button>
        </div>
      </div>

      {orders.length === 0 ? <p className="text-sm text-slate-600" data-id="element-1358">No Record Found</p> : <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1359">
          <div className="overflow-x-auto" data-id="element-1360">
            <table className="w-full text-sm text-left" data-id="element-1361">
              <thead className="bg-slate-800 text-white font-medium" data-id="element-1362">
                <tr data-id="element-1363">
                  <th className="px-3 py-3 border-r border-slate-700 w-8" data-id="element-1364">
                    <input type="checkbox" className="rounded border-slate-500" data-id="element-1365" />
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700" data-id="element-1366">
                    Order Number
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700" data-id="element-1367">
                    Products
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1368">
                    Subtotal
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 w-28" data-id="element-1369">
                    Status
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700" data-id="element-1370">
                    Customer Name
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1371">
                    Date
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1372">
                    Total
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-1373">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-1374">
                {orders.map(order => <tr key={order.id} className="hover:bg-slate-50" data-id="element-1375">
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1376">
                      <input type="checkbox" className="rounded border-slate-300" data-id="element-1377" />
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1378">
                      {order.orderNumber}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1379">
                      {order.products}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1380">
                      {order.subtotal}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1381">
                      <select defaultValue={order.status} className="h-7 text-xs rounded border border-slate-300 bg-white px-1 focus:outline-none focus:ring-1 focus:ring-slate-400 w-full" data-id="element-1382">
                        <option data-id="element-1383">Failed</option>
                        <option data-id="element-1384">Processed</option>
                        <option data-id="element-1385">Not Finished</option>
                      </select>
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1386">
                      {order.customer}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1387">
                      {order.date}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" data-id="element-1388">
                      {order.total}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-1389">
                      <Link to={`/custom/orders/print_order/${order.id}`} target="_blank" data-id="element-1390">
                        <button title="Print Order" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-1391">
                          <Printer className="h-4 w-4" data-id="element-1392" />
                        </button>
                      </Link>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>}
    </div>;
}